import { PushpinFilled, PushpinOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "../ui";

/** The product resolves whether the current page can be pinned and persists the action. */
export type AppShellPinButtonProps = { pinned: boolean; label: string; onToggle: () => void };
export function AppShellPinButton({ pinned, label, onToggle }: AppShellPinButtonProps) {
  return (
    <Tooltip title={label}>
      <Button type="text" aria-label={label} icon={pinned ? <PushpinFilled /> : <PushpinOutlined />} onClick={onToggle} />
    </Tooltip>
  );
}
